// Maps country names (as they appear in profile-view location strings) to ISO 3166-1 alpha-2 codes,
// then resolves a small flag image from flagcdn. Used by the Profile Views table.

const COUNTRY_TO_ISO = {
    // Common aliases first
    "usa": "us",
    "u.s.a.": "us",
    "u.s.": "us",
    "us": "us",
    "united states": "us",
    "united states of america": "us",
    "america": "us",
    "uk": "gb",
    "u.k.": "gb",
    "united kingdom": "gb",
    "great britain": "gb",
    "england": "gb",
    "uae": "ae",
    "united arab emirates": "ae",
    "south korea": "kr",
    "korea": "kr",
    "north korea": "kp",
    "russia": "ru",
    "russian federation": "ru",
    "czech republic": "cz",
    "czechia": "cz",

    // Alphabetical
    "afghanistan": "af",
    "albania": "al",
    "algeria": "dz",
    "argentina": "ar",
    "australia": "au",
    "austria": "at",
    "bahrain": "bh",
    "bangladesh": "bd",
    "belgium": "be",
    "brazil": "br",
    "bulgaria": "bg",
    "canada": "ca",
    "chile": "cl",
    "china": "cn",
    "colombia": "co",
    "croatia": "hr",
    "cyprus": "cy",
    "denmark": "dk",
    "egypt": "eg",
    "estonia": "ee",
    "ethiopia": "et",
    "finland": "fi",
    "france": "fr",
    "germany": "de",
    "ghana": "gh",
    "greece": "gr",
    "hong kong": "hk",
    "hungary": "hu",
    "iceland": "is",
    "india": "in",
    "indonesia": "id",
    "iran": "ir",
    "iraq": "iq",
    "ireland": "ie",
    "israel": "il",
    "italy": "it",
    "japan": "jp",
    "jordan": "jo",
    "kazakhstan": "kz",
    "kenya": "ke",
    "kuwait": "kw",
    "latvia": "lv",
    "lebanon": "lb",
    "lithuania": "lt",
    "luxembourg": "lu",
    "malaysia": "my",
    "mexico": "mx",
    "morocco": "ma",
    "nepal": "np",
    "netherlands": "nl",
    "new zealand": "nz",
    "nigeria": "ng",
    "norway": "no",
    "oman": "om",
    "pakistan": "pk",
    "peru": "pe",
    "philippines": "ph",
    "poland": "pl",
    "portugal": "pt",
    "qatar": "qa",
    "romania": "ro",
    "saudi arabia": "sa",
    "serbia": "rs",
    "singapore": "sg",
    "slovakia": "sk",
    "slovenia": "si",
    "south africa": "za",
    "spain": "es",
    "sri lanka": "lk",
    "sweden": "se",
    "switzerland": "ch",
    "taiwan": "tw",
    "thailand": "th",
    "turkey": "tr",
    "ukraine": "ua",
    "uruguay": "uy",
    "venezuela": "ve",
    "vietnam": "vn",
};

// Extract the country portion from a "City, Country" style string.
export const extractCountry = (location) => {
    if (!location) return "";
    return String(location).split(",").pop().trim();
};

// Resolve an ISO2 code for a country name (case/whitespace insensitive). Returns "" if unknown.
export const getCountryCode = (countryName) => {
    if (!countryName) return "";
    const key = String(countryName).trim().toLowerCase();
    return COUNTRY_TO_ISO[key] || "";
};

// Resolve a flag image URL for a country name. Returns "" when the country is not mapped.
export const getFlagUrl = (countryName) => {
    const code = getCountryCode(countryName);
    return code ? `https://flagcdn.com/w40/${code}.png` : "";
};

// Resolve a flag image URL directly from an ISO 3166-1 alpha-2 code (e.g. "US", "in").
// Returns "" when no code is provided.
export const getFlagUrlByIso = (iso2) => {
    const code = String(iso2 || "").trim().toLowerCase();
    return code ? `https://flagcdn.com/w40/${code}.png` : "";
};
